import {
  usePageNumberFromUrl,
  usePerPageValueFromUrl,
  useSortValueFromUrl,
} from 'idsk-react-components';
import { SortDirectionEnum } from 'elegislativa-frontend-ts-axios';
import { useParams } from 'react-router';
import {
  defaultPerPageValue,
  perPageDataArray,
} from '../../../../../constants/PaginationPerPageConstants';
import { useClientFetch } from '../../../../../context/ClientStatusContext';
import { ClientStatus } from '../../../../../model/ClientStatus';
import { fetchUlohyOrganizacieDetailPage }
  from '../../../../../client/legislativnyMaterial/ulohyOrganizacieDetailClient';
import LegislativnyMaterialUlohaListPage
  from '../../../../../model/legislativnyMaterial/ulohy/LegislativnyMaterialUlohaListPage';
import useSearchTextFilterFromUrl from '../../../../../hooks/useSearchTextFilterFromUrl';
import getUlohySort from '../../../../../function/getUlohySort';

interface ReturnType {
  ulohyOrganizacieDetailPage: LegislativnyMaterialUlohaListPage;
  ulohyOrganizacieDetailStatus: ClientStatus;
  pageNumber: number;
  searchText: string;
  reloadUlohyPage;
}

const getSortDirection = (sort): SortDirectionEnum => (sort[1] === 'desc'
  ? SortDirectionEnum.Desc
  : SortDirectionEnum.Asc);

export default (): ReturnType => {
  const { uuid } = useParams<{ uuid: string }>();
  const { page } = usePageNumberFromUrl();
  const { perPageValue } = usePerPageValueFromUrl('perPage', perPageDataArray, defaultPerPageValue);
  const { sort } = useSortValueFromUrl();
  const filter = useSearchTextFilterFromUrl();

  const {
    data: ulohyOrganizacieDetailPage,
    status: ulohyOrganizacieDetailStatus,
    refetch: reloadUlohyPage,
  } = useClientFetch(
    fetchUlohyOrganizacieDetailPage,
    [uuid, page, perPageValue, getUlohySort(sort[0]), getSortDirection(sort), filter ? filter.trim() : filter],
    [uuid, page, perPageValue, sort[0], sort[1], filter],
  );

  return {
    ulohyOrganizacieDetailPage,
    ulohyOrganizacieDetailStatus,
    pageNumber: page,
    searchText: filter,
    reloadUlohyPage,
  };
};
